import { render, staticRenderFns } from "./RecipeSearch.vue?vue&type=template&id=37083e0e&scoped=true"
import script from "./RecipeSearch.vue?vue&type=script&lang=js"
export * from "./RecipeSearch.vue?vue&type=script&lang=js"
import style0 from "./RecipeSearch.vue?vue&type=style&index=0&id=37083e0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37083e0e",
  null
  
)

export default component.exports